var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeutralMoodLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 297,
    height: 207,
    viewBox: "0 0 297 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M207.532 32.4757C223.221 45.8161 231.123 66.3993 232.963 86.9478C250.26 91.0783 273.424 110.111 273.424 135.473C273.424 168.529 239.13 184.021 225.963 183.986L65.2776 183.535C38.9672 183.466 19.136 160.418 17.1575 135.427C15.3179 112.171 29.8499 94.2485 47.2398 82.1693C45.0299 67.348 52.1571 55.4308 63.785 48.7549C75.8179 41.8475 89.8988 40.8409 102.487 48.9978C116.082 30.4163 134.964 18.2445 158.521 17.0875C174.742 16.2892 193.949 20.9172 207.532 32.4757Z",
    fill: "url(#paint0_linear_5022_13969)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5022_13969",
    x1: 241.284,
    y1: 17,
    x2: 49.1396,
    y2: 183.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84C7D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32A1B3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutralMoodLeftIcon);
export default __webpack_public_path__ + "static/media/neutralMoodLeftIcon.7b4f5bf9fa75a47315ee7bc5361b752f.svg";
export { ForwardRef as ReactComponent };